/**
 * @fileoverview POST handler for the "/ai_agent/gemini_interactions/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { aiAgentGeminiInteractionsAppGroupIdCacheKeys } from "./constants";
import type {
  AiAgentGeminiInteractionsAppGroupIdResult,
  PostAiAgentGeminiInteractionsAppGroupIdProps,
} from "./types";

export const postAiAgentGeminiInteractionsAppGroupId = reactQueryMutationAdapter(
  aiAgentGeminiInteractionsAppGroupIdCacheKeys,
  ({
    appGroupId,
    requestId,
    userMessageId,
    sessionId,
    model,
    input,
    mode,
    previousInteractionId,
    frontendTools,
    locale,
    browserLocale,
    transport,
    promptSource,
  }: PostAiAgentGeminiInteractionsAppGroupIdProps): Promise<AiAgentGeminiInteractionsAppGroupIdResult> => {
    return fetch(
      `/ai_agent/gemini_interactions/${appGroupId}`,
      "POST",
      {
        model,
        input,
        mode,
        previous_interaction_id: previousInteractionId,
        request_id: requestId,
        user_message_id: userMessageId,
        session_id: sessionId,
        frontend_tools: frontendTools,
        locale,
        browser_locale: browserLocale,
        transport,
        prompt_source: promptSource,
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
